module.exports = __webpack_public_path__ + "img/video.3f0eddb9.png";